import * as React from "react";

interface GymReportIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  size?: number | string;
}

export const GymReportIcon = React.forwardRef<
  SVGSVGElement,
  GymReportIconProps
>(({ className, size = 38, width, height, ...props }, ref) => (
  <svg
    ref={ref}
    width={width || size}
    height={height || size}
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M10.2738 6.95996H9.12714C8.02737 6.95996 6.97265 7.39684 6.195 8.17449C5.41735 8.95214 4.98047 10.0069 4.98047 11.1066V25.8533C4.98047 26.9531 5.41735 28.0078 6.195 28.7854C6.97265 29.5631 8.02737 30 9.12714 30H23.8738C24.9736 30 26.0283 29.5631 26.8059 28.7854C27.5836 28.0078 28.0205 26.9531 28.0205 25.8533V11.1066C28.0205 10.0069 27.5836 8.95214 26.8059 8.17449C26.0283 7.39684 24.9736 6.95996 23.8738 6.95996H22.7138V8.49329C22.7138 8.61586 22.6897 8.73723 22.6428 8.85047C22.5959 8.9637 22.5271 9.06659 22.4404 9.15326C22.3538 9.23993 22.2509 9.30868 22.1376 9.35558C22.0244 9.40249 21.903 9.42663 21.7805 9.42663H11.1671C11.0435 9.4284 10.9207 9.40556 10.8059 9.35945C10.6911 9.31333 10.5866 9.24486 10.4985 9.15802C10.4104 9.07118 10.3405 8.96769 10.2928 8.85357C10.245 8.73946 10.2205 8.61699 10.2205 8.49329L10.2738 6.95996Z"
      fill="currentColor"
    />
    <path
      d="M13.6055 13.9468V16.8534"
      stroke="#131415"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.6598 15.3999H12.3398"
      stroke="#131415"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.6598 21.48H12.3398"
      stroke="#131415"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.6598 25.5332H12.3398"
      stroke="#131415"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.275 8.49333V6.66667C10.2678 6.5423 10.2852 6.41774 10.3263 6.30012C10.3673 6.1825 10.4311 6.07414 10.5141 5.98124C10.5971 5.88834 10.6976 5.81273 10.8099 5.75875C10.9222 5.70477 11.044 5.67348 11.1684 5.66667H13.5284C13.508 5.45827 13.508 5.24839 13.5284 5.04C13.5284 4.23374 13.8486 3.46051 14.4188 2.8904C14.9889 2.32028 15.7621 2 16.5684 2C17.3746 2 18.1478 2.32028 18.718 2.8904C19.2881 3.46051 19.6084 4.23374 19.6084 5.04C19.6287 5.24839 19.6287 5.45827 19.6084 5.66667H21.835C21.9587 5.66665 22.0812 5.69123 22.1953 5.73897C22.3094 5.7867 22.4129 5.85665 22.4997 5.94473C22.5866 6.03282 22.6551 6.13729 22.7012 6.25207C22.7473 6.36685 22.7701 6.48965 22.7684 6.61333V8.49333C22.7684 8.6159 22.7442 8.73727 22.6973 8.8505C22.6504 8.96374 22.5817 9.06663 22.495 9.1533C22.4083 9.23997 22.3054 9.30872 22.1922 9.35562C22.079 9.40252 21.9576 9.42667 21.835 9.42667H11.1684C10.9278 9.41635 10.7006 9.31348 10.5341 9.13955C10.3676 8.96562 10.2748 8.73409 10.275 8.49333Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.3945 13.9468V16.8534"
      stroke="#141515"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));

GymReportIcon.displayName = "GymReportIcon";

GymReportIcon.displayName = "GymReportIcon";
